function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTagsimple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M2.654 4.904A1.55 1.55 0 013.75 4.45h13.849a1.55 1.55 0 011.29.69l4.277 6.416a.8.8 0 010 .888l-4.278 6.416a1.55 1.55 0 01-1.29.69H3.75A1.55 1.55 0 012.2 18V6c0-.411.163-.805.454-1.096zM3.8 6.05v11.9h13.772L21.539 12l-3.967-5.95z",
    fill: props.fill,
    fillRule: "evenodd"
  }));
}

export default SvgTagsimple;